import TextField from "../../../../components/fields/textField/TextField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import FormModal from "../../../../components/dialog/forms/FormModal.vue";
import { SnackbarMixin } from "../../../../mixins/snackbarMixin.js";
import { AssinaturaMixin } from "../../../../mixins/assinaturaMixin";

import PerfilService from "../../../../services/PerfilService";
import {SnackBarModule} from "@/modules/SnackBarModule";

export default {
  name: "DialogAssociar",
  components: {
    TextField,
    ConfirmPasswordDialog,
    FormModal,
    SnackBarModule
  },
  mixins:[SnackbarMixin,AssinaturaMixin],
  props: {
    activeDialog: {
      type: Boolean,
      default: false,
    },
    userSelected: {
      required: true,
    },
    dataPerfis: {
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: "Perfil", value: "nome", sortable: false },
      { text: "", value: "atribuir", sortable: false, width: "100" },
    ],
    data: [],
    errors: [],
    disabled: {
      perfil: false,
    },
    form: {},
    formValid: true,
    loading: {
      table: false,
    },
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    showFormDialog: false,
    countCheck:0,
    showFormDialogModal: {
      associar: false,
      remove: false,
      confirmRemove: false,
      editPerfil: false,
    },
    showDialogConfirmPassword: false,
    formConfirmPassword: {},
    send: {
      function: () => {},
      params: null,
    },

    perfis: [],
  }),
  watch: {
    dataPerfis(perfis) {
      this.data = perfis.filter((perfil) => perfil.id != 2);
    },
    checkValue() {
      console.log(this.countCheck);
      console.log('in wa');
      this.$emit('evCount',this.countCheck);
    },
    activeDialog() {
      this.addUserInfo();
      this.showFormDialog = !this.showFormDialog;
    },
  },

  created() {
    this.initializeFormConfirmPassword();
    this.initializeForm();
  },

  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    addUserInfo() {
      console.log(this.userSelected.pessoas_perfis.length)
      this.form.perfisUser = this.userSelected.pessoas_perfis.map(
        function (item){
          return item.perfil.id;

        }
      );
    },
    countCheckData() {
      console.log('in method');
      this.countCheck = + 1;
      console.log(this.countCheck);
    },
    async checkboxChange(perfilid) {

      this.disabled.perfil = true;
      let response;
      let message = "";
      if (this.form.perfisUser.includes(perfilid)) {
        response = await PerfilService.addPerfilUser(
          perfilid,
          this.userSelected.id,
        );
        message = "Perfil atribuído ao usuário com sucesso";
      } else {
        response = await PerfilService.removePerfilUser(
          perfilid,
          this.userSelected.id,
        );
        message = "Perfil removido do usuário com sucesso";
      }

      if (response.error) {
        SnackBarModule(response.error, "error");
      } else {
        console.log(message);
        SnackBarModule("Sucesso!","success");
      }
      this.disabled.perfil = false;

      this.countCheckData(this.form.perfisUser.length);
      console.log(this.countCheck);
    },

    initializeForm() {
      this.form = {
        perfisUser: [],
      };
    },

    async save() {
      this.errors = [];
      let response = await PerfilService.atribuirFuncionalidadePerfil(
        this.perfilid,
        this.form,
      );

      if (!response.error) {
        this.showSnackbar(
          "As funcionalidades foram adicionadas ao perfil com sucesso",
        );
        this.showFormDialog = !this.showFormDialog;
      } else {
        const message = await response.response;
        this.showSnackbar(message, "error");
        this.errors.push(message);
      }
    },

    closed() {
      this.$emit("closed");
    },
  },
};
